import React, { useContext, useState } from "react";
import { getIcon, getLink, tabs } from "../../utils";
import userFallback from "../../images/user.svg";
import _ from "lodash";
import "./card.scss";
import GlobalContext from "../../context/GlobalContext";
import MaterialIcons from "../MaterialIcons";
import Chip from "../Chip/Chip";

const Card = ({
	image,
	name,
	title,
	status,
	socials,
	verified,
	roll,
	tags,
	color = "light-blue",
}) => {
	const [userImage, setUserImage] = useState(image);
	const { isAuthenticated, updateMember, removeMember } =
		useContext(GlobalContext);
	const verifyMember = async (e) => {
		e?.preventDefault();
		await updateMember({ roll: roll, verified: true });
	};
	const deleteMember = async (e) => {
		e?.preventDefault();
		await removeMember(roll);
	};
	return (
		<div className="card">
			<div
				className="card-front"
				style={{
					backgroundColor: `var(--${color})`,
					backgroundImage: `url(${userImage})`,
				}}
			></div>
			<div
				className="card-back"
				style={{
					backgroundColor: `var(--${color}-100)`,
				}}
			>
				{isAuthenticated && (
					<div className="card-head">
						{!verified && (
							<button
								className="icon"
								style={{ color: "var(--green)" }}
								title={`Verify ${name} as a team member`}
								onClick={verifyMember}
							>
								<MaterialIcons>done</MaterialIcons>
							</button>
						)}
						<button
							className="icon"
							style={{ color: "var(--red)" }}
							title={
								verified
									? `Remove ${name} from the team`
									: `Decline ${name}'s request to join the team`
							}
							onClick={deleteMember}
						>
							<MaterialIcons>close</MaterialIcons>
						</button>
					</div>
				)}
				<div className="card-image">
					<img
						src={userImage}
						onError={() => setUserImage(userFallback)}
						alt={name}
						loading="lazy"
					/>
				</div>
				<div className="card-content">
					<div className="card-name">{name}</div>
					<div className="card-title">{title}</div>
					<div className="card-status">{status}</div>
					<div className="card-socials">
						{socials?.map(
							(social, id) =>
								social.username && (
									<a
										href={getLink(
											social.service,
											social.username
										)}
										title={`${social.service}/${social.username}`}
										key={id}
										target="_blank"
										rel="noreferrer"
										className={`card-social ${_.lowerCase(
											social.service
										)}`}
									>
										{getIcon(social.service)}
									</a>
								)
						)}
					</div>
					<div className="card-teams">
						{tags
							.map((tag) => tabs.find((tab) => tab.id === tag))
							.map((tab, index) => (
								<Chip
									key={index}
									icon={tab.icon}
									text={tab.title}
									size="small"
									style={{
										backgroundColor: `var(--${tab.color}-700)`,
										color: `var(--white)`,
										border: `2px solid var(--${
											tab.color - 700
										})`,
									}}
								/>
							))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Card;
